import React, { useEffect } from "react";
import "./App.css";
import "./index.css";
import { useLocation, useNavigate } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import About_Us from "./components/about-us/About_Us";
import Services from "./components/services/Services";
import Service_Inner_Page from "./components/services/service-inner-page/Service_Inner_Page";
import Blogs from "./components/blogs/Blogs";
import Blog_Inner_Page from "./components/blogs/blog-inner-page/Blog_Inner_Page";
import Contact_us from "./components/contact-us/Contact.Us";
import Gallery from "./components/gallery/Gallery";

import Faq from "./components/faq/Faq";
import Privacy_Policy from "./components/privacy-policy/Privacy_Policy";
import Terms_Of_Service from "./components/terms-of-service/Terms_Of_Service";
import ScrollToTop from "./components/scrolltotop/ScrollToTop";
import Subsidy_Policy from "./components/subsidy-policy/Subsidy_Policy";
import New_Highlight_Inner_Page from "./components/subsidy-policy/new-highlights/new-highlight-inner-page/New_Highlight_Inner_Page";
import GallaryShowcase from "./components/gallary_showcase/GallaryShowcase";
import GalleryInner from "./components/gallary_showcase/gallery-inner/Gallery_Inner";
import EffectInfo from "./components/effects_page/category_tabs/fire/effect_info/EffectInfo";
import EffectsPage from "./components/effects_page/EffectsPage";
import ProductDetails from "./components/effects_page/category_tabs/fire/product_section/product_inner/product_details/ProductDetails";
import ProductInner from "./components/effects_page/category_tabs/fire/product_section/product_inner/ProductInner";
import BlogInner from "./components/blogs/blog_inner/BlogInner";
import StartVideo from "./components/start_video/StartVideo";
import CategoryTabs from "./components/effects_page/category_tabs/CategoryTabs";

function App() {
  const location = useLocation();

  // const isVideoPage = location.pathname === "/";
  const isVideoPage = location.pathname === "/starting";
  const isGalleryInner = location.pathname.startsWith("/gallery-inner");
  const navigate = useNavigate();

  // useEffect(() => {
  //   const isMobile = window.innerWidth <= 768;

  //   if (isMobile && location.pathname === "/") {
  //     navigate("/starting", { replace: true });
  //   }
  // }, [location.pathname, navigate]);
  useEffect(() => {
    const isMobile = window.innerWidth <= 768;

    // Clear session flag on refresh
    sessionStorage.removeItem("introPlayed");

    const introPlayed = sessionStorage.getItem("introPlayed");

    if (isMobile && location.pathname === "/" && !introPlayed) {
      sessionStorage.setItem("introPlayed", "true");
      navigate("/starting", { replace: true });
    }
  }, []);
  return (
    <>
      <ScrollToTop />
      {!isVideoPage && <Header />}
      <Routes>
        {/* <Route path="/home" element={<Home />} /> */}
        <Route path="/" element={<Home />} />
        {/* <Route path="/" element={<StartVideo />} /> */}
        <Route path="/starting" element={<StartVideo />} />
        <Route path="/subsidy-policy" element={<Subsidy_Policy />} />
        <Route path="/about-us" element={<About_Us />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:id" element={<Service_Inner_Page />} />
        <Route path="/blog" element={<Blogs />} />
        <Route path="/blog/:id" element={<BlogInner />} />
        <Route path="/contact-us" element={<Contact_us />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/gallery-inner/:id" element={<GalleryInner />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/privacy-policy" element={<Privacy_Policy />} />
        <Route path="/terms-of-services" element={<Terms_Of_Service />} />
        <Route path="/gallery-showcase" element={<GallaryShowcase />} />
        <Route
          path="/new-highlight-inner-page"
          element={<New_Highlight_Inner_Page />}
        />{" "}
        <Route path="/effects" element={<EffectsPage />} />
        <Route path="/effect/:id" element={<EffectInfo />} />
        <Route path="/product-details" element={<ProductInner />} />
        <Route path="/product/:id" element={<ProductDetails />} />
        <Route path="/categories" element={<CategoryTabs />} />
      </Routes>
      {!isVideoPage && !isGalleryInner && <Footer />}
    </>
  );
}

export default App;
